import React, { useEffect, useState } from 'react';
import Button from 'components/customDesign/Button';
import { Link } from 'react-router-dom';
import erlClient from 'services/clients';
import ListInfoItem from 'components/customDesign/ListInfoItem';
import { SegmentService } from 'services/helpers/segment';
import fonts from 'styles/typography.module.css';

interface Props {
  scac: string;
}

const NeedValidation: React.FC<Props> = (props) => {
  const { scac } = props;
  const [emails, setEmails] = useState<string[] | null>(null);
  const [APICalled, setAPICalled] = useState(false);
  useEffect(() => {
    if (!APICalled) {
      erlClient(`core/api/v1/auth/company/${scac}/admins`)
        .then((res) => {
          setAPICalled(true);
          setEmails(res.data);
        })
        // eslint-disable-next-line no-console
        .catch(console.error);
    }
  });

  return (
    <div className={`${fonts.fonts} space-y-2 flex flex-col items-center gap-4`}>
      <h5 className="text-center text-gray-400">Join a company</h5>
      <div className="space-y-3 pl-8">
        <ListInfoItem
          primary="Your company is already a client"
          secondary="We've asked your team to grant you membership"
        />
        <ListInfoItem
          primary="Wait for approval"
          secondary="You will automatically have access to the platform once you're approved"
        />
        <ListInfoItem
          primary="In a hurry?"
          secondary={
            emails && <span>Ask in person {emails.join(', ')} to accept your request!</span>
          }
        />
      </div>
      <Button
        // eslint-disable-next-line
        // @ts-ignore
        component={Link}
        to="/welcome?company=true"
        onClick={() => SegmentService.trackEventNoSlack('Ask to join the company')}
        classes={{ root: 'text-center w-[250px]' }}
      >
        Ask to join the company
      </Button>
      <div>
        <h5 className="underline text-gray-400 text-center">
          <a href="mailto:support@bluecargo.io">Contact us</a>
        </h5>
      </div>
    </div>
  );
};
NeedValidation.displayName = 'Settings.Profile.NeedValidation';

export default NeedValidation;
